<template>
  <Admin style="background: #f2f2f2;">
    <v-main>
      <profile-detail></profile-detail>
    </v-main>
  </Admin>
</template>


<script>
import Admin from '../components/admin/admin-main-template'
import ProfileDetail from '../components/admin/profile/profile-detail'

export default {
  name: "Profile",
  components: {
    Admin,
    ProfileDetail
  }
}
</script>

